<script>
  import './polyfill.js'
  import mpx, { createApp } from '@mpxjs/core'
  import apiProxy from '@mpxjs/api-proxy'

  // 显式引入 Vue 以修补原型链
  import Vue from 'vue'

  mpx.use(apiProxy, {
    usePromise: true
  })

  // CRITICAL FIX: Ensure Vue.version exists IMMEDIATELY after import
  if (!Vue.version) {
    Vue.version = '2.7.16'
  }

  // 强力修复: 直接在 Vue 原型上添加 getRelationNodes
  if (!Vue.prototype.getRelationNodes) {
    Vue.prototype.getRelationNodes = function() {
      return []
    }
    console.log('[Polyfill] Vue.prototype.getRelationNodes injected')
  }

  // 修复 tdesign-miniprogram 组件在 Web 端运行时缺少 getRelationNodes 的问题
  mpx.mixin({
    methods: {
      getRelationNodes() {
        return []
      }
    }
  })

  // 确保全局 wx 存在 (针对 Web 平台)
  if (typeof window !== 'undefined') {
    if (!window.wx || !window.wx.request) {
      window.wx = Object.assign(window.wx || {}, {
        request: mpx.request.bind(mpx),
        downloadFile: mpx.downloadFile.bind(mpx),
        uploadFile: mpx.uploadFile.bind(mpx)
      })
    }
    
    // MPX 框架必需的辅助函数
    const helpers = {
      __ensureString (val) {
        if (typeof val === 'string') return val
        return val == null ? '' : String(val)
      },
      __invoke (e, handlers) {
        if (!handlers) return
        handlers.forEach((handler) => {
          const handlerName = handler[0]
          if (typeof this[handlerName] === 'function') {
            this[handlerName].apply(this, [e].concat(handler.slice(1)))
          }
        })
      }
    }
    
    Object.assign(mpx.prototype, helpers)
  }

  createApp({
      onLaunch () {
        console.log('App Launch - H5 Testing Phase 1')
      }
  })
</script>

<style>
  html, body, #app {
    height: 100%;
    margin: 0;
    padding: 0;
  }
</style>

<script type="application/json">
  {
    "pages": [
      "./pages/index/index"
    ],
    "window": {
      "navigationBarTitleText": "产品画册"
    }
  }
</script>
